import { Combobox, Transition } from '@headlessui/react';
import cn from 'classnames';
import { Fragment } from 'react';
import { MdExpandMore } from 'react-icons/md';

interface PositionGroupSwitchProps {}

const options = [
    { label: 'None', value: 'None' },
    { label: 'Products', value: 'Products' }
];

export type GroupBy = 'None' | 'Products';

interface PositionGroupSwitchProps {
    groupBy: GroupBy;
    setGroupBy: (groupBy: GroupBy) => void;
    className?: string;
}

const PositionGroupSwitch = (props: PositionGroupSwitchProps) => {
    const { groupBy, setGroupBy, className } = props;

    return (
        <div className="flex items-center justify-between gap-2">
            {/* TBA - Translations (I am not sure if this is needed, but i will just mark it just in case) */}
            <span className="text-brand-neutral-500 text-xs whitespace-nowrap">Group By :</span>
            <Combobox value={groupBy} onChange={(option) => setGroupBy(option)}>
                <div className={cn('relative w-full')}>
                    <div
                        className={cn(
                            'relative w-full cursor-default overflow-hidden bg-brand-background-dark border border-brand-neutral-700 hover:border-brand-neutral-600 text-left sm:text-xs',
                            className
                        )}>
                        <Combobox.Button className="w-full py-1.5 pl-3 pr-8 text-left text-xs leading-5 text-brand-text truncate">
                            <div>{groupBy}</div>
                            <div className="absolute inset-y-0 right-0 flex items-center pr-1">
                                <MdExpandMore className="h-5 w-5 text-brand-neutral-200" aria-hidden="true" />
                            </div>
                        </Combobox.Button>
                    </div>
                    <Transition
                        as={Fragment}
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0">
                        <Combobox.Options
                            className={cn(
                                'absolute mt-2 z-[60] flex cursor-default bg-brand-background-dark border border-brand-neutral-700 text-xs shadow-lg shadow-brand-neutral-900 overflow-clip right-0',
                                className
                            )}>
                            <div className="flex flex-col w-28 max-h-60 overflow-auto">
                                {options.map((option, optionIdx) => {
                                    return (
                                        <Combobox.Option
                                            key={optionIdx}
                                            className="relative cursor-pointer select-none py-2 pl-2 pr-4 group hover:bg-brand-primary text-brand-text"
                                            value={option.value}>
                                            <span className="block truncate">{option?.label}</span>
                                        </Combobox.Option>
                                    );
                                })}
                            </div>
                        </Combobox.Options>
                    </Transition>
                </div>
            </Combobox>
        </div>
    );
};

export default PositionGroupSwitch;
